<template>
  <section>
    <section style="margin-bottom: 4em">
      <h1 class="text-center" style="font-size: 22px">School Setup</h1>
    </section>
    <div
      class="alert alert-warning"
      v-if="skippedCities && skippedCities.length > 0"
    >
      We couldn't find ZIP codes for:
      {{ skippedCities.join(", ") }}. You can refine your service area later
      under Settings.
    </div>
    <section v-if="step == 'step1'">
      <form>
        <div class="col-xs-12">
          <p class="text-center" style="font-size: 18px; margin-bottom: 2em">
            This is the first name, lastname and phone number of your Owner level
            account.
          </p>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_firstname">Owner First Name</label>
            <input
              class="form-control"
              id="school_setup_firstname"
              type="text"
              v-model="step1.firstname"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_lastname">Owner Last Name</label>
            <input
              class="form-control"
              id="school_setup_lastname"
              type="text"
              v-model="step1.lastname"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_phone">Owner Phone Number</label>
            <input
              class="form-control"
              id="school_setup_phone"
              type="text"
              v-model="step1.phone"
            />
          </div>
          <div class="text-center" style="margin-top: 2em; margin-bottom: 2em">
            <button
              class="btn btn-dc"
              @click.prevent="setStep('step1', 'step2')"
            >
              Next
            </button>
          </div>
        </div>
      </form>
    </section>
    <section v-if="step == 'step2'">
      <form>
        <div class="col-xs-12">
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_school_name">School Name</label>
            <input
              class="form-control"
              id="school_setup_school_name"
              type="text"
              v-model="step2.school_name"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_school_phone">School Phone</label>
            <input
              class="form-control"
              id="school_setup_school_phone"
              type="text"
              v-model="step2.school_phone"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_school_email">School Email</label>
            <input
              class="form-control"
              id="school_setup_school_email"
              type="text"
              v-model="step2.school_email"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_school_timezone">School Timezone</label>
            <select
              class="form-control"
              id="school_setup_school_timezone"
              v-model="step2.school_timezone"
            >
              <option value="America/New_York">Eastern</option>
              <option value="America/Los_Angeles">Pacific</option>
              <option value="America/Chicago">Central</option>
              <option value="America/Phoenix">Mountain Time (No DST)</option>
              <option value="America/Denver">Mountain Time</option>
            </select>
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_street">School Street</label>
            <input
              class="form-control"
              id="school_setup_street"
              type="text"
              v-model="step2.address.street"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_city">School City</label>
            <input
              class="form-control"
              id="school_setup_city"
              type="text"
              v-model="step2.address.city"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_state">School State</label>
            <input
              class="form-control"
              id="school_setup_state"
              type="text"
              v-model="step2.address.state"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="school_setup_zip">School Zip Code</label>
            <input
              class="form-control"
              id="school_setup_zip"
              type="text"
              v-model="step2.address.zip"
            />
          </div>
          <div class="text-center" style="margin-top: 2em; margin-bottom: 2em">
            <button
              class="btn btn-dc"
              @click.prevent="setStep('step2', 'step1')"
            >
              Prev
            </button>
            <button
              class="btn btn-dc"
              @click.prevent="setStep('step2', 'step3')"
            >
              Next
            </button>
          </div>
        </div>
      </form>
    </section>
    <section v-if="step == 'step3'">
      <form>
        <div class="col-xs-12">
          <p class="text-center" style="font-size: 18px; margin-bottom: 2em">
            Which cities do you serve? We'll build a service area with a zone
            for each city you list. You can refine it later, or skip this step
            if you don't limit where you pick students up.
          </p>
          <div
            class="form-group"
            style="margin-bottom: 1em"
            v-for="(city, index) in step3.cities"
            :key="'city-' + index"
          >
            <label :for="'school_setup_city_' + index">City</label>
            <div style="display: flex; gap: 8px">
              <input
                class="form-control"
                :id="'school_setup_city_' + index"
                type="text"
                placeholder="e.g. Long Beach"
                v-model="step3.cities[index]"
              />
              <button
                class="btn btn-danger"
                v-if="step3.cities.length > 1"
                @click.prevent="removeCity(index)"
              >
                Remove
              </button>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-default" @click.prevent="addCity()">
              Add Another City
            </button>
          </div>
          <div class="text-center" style="margin-top: 2em; margin-bottom: 2em">
            <button
              class="btn btn-dc"
              @click.prevent="setStep('step3', 'step2')"
            >
              Prev
            </button>
            <button class="btn btn-default" @click.prevent="skipStep(3)">
              Skip This
            </button>
            <button
              class="btn btn-dc"
              :disabled="cityNames.length === 0"
              @click.prevent="saveStepThree()"
            >
              Next
            </button>
          </div>
        </div>
      </form>
    </section>
    <section v-if="step == 'step4'">
      <form>
        <div class="col-xs-12">
          <p class="text-center" style="font-size: 18px; margin-bottom: 2em">
            Who are your instructors? We'll email each of them an invitation to
            create their own account with their own password.
          </p>
          <div
            class="row"
            v-for="(instructor, index) in step4.instructors"
            :key="'instructor-' + index"
            style="margin-bottom: 1em"
          >
            <div class="form-group col-xs-12 col-sm-3">
              <label :for="'instructor_firstname_' + index">First Name</label>
              <input
                class="form-control"
                :id="'instructor_firstname_' + index"
                type="text"
                v-model="instructor.firstname"
              />
            </div>
            <div class="form-group col-xs-12 col-sm-3">
              <label :for="'instructor_lastname_' + index">Last Name</label>
              <input
                class="form-control"
                :id="'instructor_lastname_' + index"
                type="text"
                v-model="instructor.lastname"
              />
            </div>
            <div class="form-group col-xs-12 col-sm-4">
              <label :for="'instructor_email_' + index">Email</label>
              <input
                class="form-control"
                :id="'instructor_email_' + index"
                type="email"
                v-model="instructor.email"
              />
            </div>
            <div class="form-group col-xs-12 col-sm-2">
              <label style="visibility: hidden; display: block">Remove</label>
              <button
                class="btn btn-danger"
                v-if="step4.instructors.length > 1"
                @click.prevent="step4.instructors.splice(index, 1)"
              >
                Remove
              </button>
            </div>
          </div>
          <div class="form-group">
            <button
              class="btn btn-default"
              @click.prevent="addInvitee(step4.instructors)"
            >
              Add Another Instructor
            </button>
          </div>
          <div class="text-center" style="margin-top: 2em; margin-bottom: 2em">
            <button
              class="btn btn-dc"
              @click.prevent="setStep('step4', 'step3')"
            >
              Prev
            </button>
            <button class="btn btn-default" @click.prevent="skipStep(4)">
              Skip This
            </button>
            <button
              class="btn btn-dc"
              :disabled="completedInvitees(step4.instructors).length === 0"
              @click.prevent="saveInvitees(4, 'instructors', step4.instructors)"
            >
              Send Invitations
            </button>
          </div>
        </div>
      </form>
    </section>
    <section v-if="step == 'step5'">
      <form>
        <div class="col-xs-12">
          <p class="text-center" style="font-size: 18px; margin-bottom: 2em">
            Who else helps run the school? We'll email each administrator an
            invitation to create their own account.
          </p>
          <div
            class="row"
            v-for="(administrator, index) in step5.administrators"
            :key="'administrator-' + index"
            style="margin-bottom: 1em"
          >
            <div class="form-group col-xs-12 col-sm-3">
              <label :for="'administrator_firstname_' + index">First Name</label>
              <input
                class="form-control"
                :id="'administrator_firstname_' + index"
                type="text"
                v-model="administrator.firstname"
              />
            </div>
            <div class="form-group col-xs-12 col-sm-3">
              <label :for="'administrator_lastname_' + index">Last Name</label>
              <input
                class="form-control"
                :id="'administrator_lastname_' + index"
                type="text"
                v-model="administrator.lastname"
              />
            </div>
            <div class="form-group col-xs-12 col-sm-4">
              <label :for="'administrator_email_' + index">Email</label>
              <input
                class="form-control"
                :id="'administrator_email_' + index"
                type="email"
                v-model="administrator.email"
              />
            </div>
            <div class="form-group col-xs-12 col-sm-2">
              <label style="visibility: hidden; display: block">Remove</label>
              <button
                class="btn btn-danger"
                v-if="step5.administrators.length > 1"
                @click.prevent="step5.administrators.splice(index, 1)"
              >
                Remove
              </button>
            </div>
          </div>
          <div class="form-group">
            <button
              class="btn btn-default"
              @click.prevent="addInvitee(step5.administrators)"
            >
              Add Another Administrator
            </button>
          </div>
          <div class="text-center" style="margin-top: 2em; margin-bottom: 2em">
            <button
              class="btn btn-dc"
              @click.prevent="setStep('step5', 'step4')"
            >
              Prev
            </button>
            <button class="btn btn-default" @click.prevent="skipStep(5)">
              Skip This
            </button>
            <button
              class="btn btn-dc"
              :disabled="completedInvitees(step5.administrators).length === 0"
              @click.prevent="
                saveInvitees(5, 'administrators', step5.administrators)
              "
            >
              Send Invitations
            </button>
          </div>
        </div>
      </form>
    </section>
    <section v-if="step == 'step6'">
      <form>
        <div class="col-xs-12">
          <p class="text-center" style="font-size: 18px; margin-bottom: 2em">
            Do you accept online payments from your students?
          </p>
          <div class="form-group text-center" style="margin-bottom: 2em">
            <label class="radio-inline">
              <input
                type="radio"
                name="accepts_online_payments"
                :value="true"
                v-model="step6.accepts_online_payments"
              />
              Yes
            </label>
            <label class="radio-inline">
              <input
                type="radio"
                name="accepts_online_payments"
                :value="false"
                v-model="step6.accepts_online_payments"
              />
              No
            </label>
          </div>
          <div v-if="step6.accepts_online_payments === true">
            <div class="form-group" style="margin-bottom: 2em">
              <label for="school_setup_gateway">Payment Provider</label>
              <select
                class="form-control"
                id="school_setup_gateway"
                v-model="step6.gateway"
              >
                <option value="">Choose your payment provider...</option>
                <option value="authorize">Authorize.Net</option>
                <option value="stripe">Stripe</option>
                <option value="paypal">PayPal</option>
                <option value="square">Square</option>
              </select>
            </div>
            <div v-if="step6.gateway">
              <div class="alert alert-info">
                {{ gatewayExplanations[step6.gateway] }}
              </div>
              <div
                class="form-group"
                style="margin-bottom: 2em"
                v-for="field in gatewayCredentialFields[step6.gateway]"
                :key="field.key"
              >
                <label :for="'school_setup_' + field.key">{{
                  field.label
                }}</label>
                <input
                  class="form-control"
                  :id="'school_setup_' + field.key"
                  type="password"
                  autocomplete="off"
                  v-model="step6.credentials[field.key]"
                />
              </div>
            </div>
          </div>
          <div class="text-center" style="margin-top: 2em; margin-bottom: 2em">
            <button
              class="btn btn-dc"
              @click.prevent="setStep('step6', 'step5')"
            >
              Prev
            </button>
            <button
              class="btn btn-dc"
              :disabled="!stepSixValid"
              @click.prevent="saveStepSix()"
            >
              Next
            </button>
          </div>
        </div>
      </form>
    </section>
    <section v-if="step == 'step7'">
      <form>
        <div class="col-xs-12">
          <p class="text-center" style="font-size: 18px; margin-bottom: 2em">
            Let's set up your Behind the Wheel lesson. You can add more products
            and fine-tune pricing later, or skip this step and finish.
          </p>
          <h3>Behind the Wheel</h3>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="btw_name">Product Name</label>
            <input
              class="form-control"
              id="btw_name"
              type="text"
              placeholder="e.g. 2 Hour Driving Lesson"
              v-model="step7.behind_the_wheel.name"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="btw_price">Price (USD)</label>
            <input
              class="form-control"
              id="btw_price"
              type="number"
              min="0"
              step="0.01"
              v-model.number="step7.behind_the_wheel.price"
            />
          </div>
          <div class="form-group" style="margin-bottom: 2em">
            <label for="btw_description">Description</label>
            <textarea
              class="form-control"
              id="btw_description"
              v-model="step7.behind_the_wheel.description"
            ></textarea>
          </div>
          <div class="row">
            <div class="form-group col-xs-6" style="margin-bottom: 2em">
              <label for="btw_hours">Lesson Length (Hours)</label>
              <input
                class="form-control"
                id="btw_hours"
                type="number"
                min="0"
                v-model.number="step7.behind_the_wheel.hours"
              />
            </div>
            <div class="form-group col-xs-6" style="margin-bottom: 2em">
              <label for="btw_minutes">Minutes</label>
              <input
                class="form-control"
                id="btw_minutes"
                type="number"
                min="0"
                max="59"
                v-model.number="step7.behind_the_wheel.minutes"
              />
            </div>
          </div>
          <hr />
          <div class="form-group" style="margin-bottom: 2em">
            <label>
              <input type="checkbox" v-model="step7.administers_road_tests" />
              We administer road tests
            </label>
          </div>
          <div v-if="step7.administers_road_tests">
            <h3>Road Test</h3>
            <div class="form-group" style="margin-bottom: 2em">
              <label for="road_test_name">Product Name</label>
              <input
                class="form-control"
                id="road_test_name"
                type="text"
                placeholder="e.g. Road Test"
                v-model="step7.road_test.name"
              />
            </div>
            <div class="form-group" style="margin-bottom: 2em">
              <label for="road_test_price">Price (USD)</label>
              <input
                class="form-control"
                id="road_test_price"
                type="number"
                min="0"
                step="0.01"
                v-model.number="step7.road_test.price"
              />
            </div>
            <div class="form-group" style="margin-bottom: 2em">
              <label for="road_test_description">Description</label>
              <textarea
                class="form-control"
                id="road_test_description"
                v-model="step7.road_test.description"
              ></textarea>
            </div>
            <div class="row">
              <div class="form-group col-xs-6" style="margin-bottom: 2em">
                <label for="road_test_hours">Road Test Length (Hours)</label>
                <input
                  class="form-control"
                  id="road_test_hours"
                  type="number"
                  min="0"
                  v-model.number="step7.road_test.hours"
                />
              </div>
              <div class="form-group col-xs-6" style="margin-bottom: 2em">
                <label for="road_test_minutes">Minutes</label>
                <input
                  class="form-control"
                  id="road_test_minutes"
                  type="number"
                  min="0"
                  max="59"
                  v-model.number="step7.road_test.minutes"
                />
              </div>
            </div>
          </div>
          <div class="text-center" style="margin-top: 2em; margin-bottom: 2em">
            <button
              class="btn btn-dc"
              @click.prevent="setStep('step7', 'step6')"
            >
              Prev
            </button>
            <button class="btn btn-default" @click.prevent="skipStep(7)">
              Skip &amp; Finish
            </button>
            <button
              class="btn btn-dc"
              :disabled="!stepSevenValid"
              @click.prevent="saveStepSeven()"
            >
              Finish Setup
            </button>
          </div>
        </div>
      </form>
    </section>
  </section>
</template>
<script>
export default {
  props: {
    user: {},
    step: "",
    schoolData: {},
    address: {},
    skippedCities: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.step1.firstname = this.user.firstname;
    this.step1.lastname = this.user.lastname;
    this.step1.phone = this.user.phone;

    this.step2.school_name = this.schoolData.school_name;
    this.step2.school_phone = this.schoolData.school_phone;
    this.step2.school_email = this.schoolData.school_email;
    this.step2.school_timezone = this.schoolData.school_timezone;

    this.step2.address.street = this.address.street;
    this.step2.address.city = this.address.city;
    this.step2.address.state = this.address.state;
    this.step2.address.zip = this.address.zip;
  },
  data() {
    return {
      step1: {
        firstname: "",
        lastname: "",
        phone: "",
      },
      step2: {
        school_name: "",
        school_phone: "",
        school_email: "",
        school_timezone: "",

        address: {
          street: "",
          city: "",
          state: "",
          zip: "",
        },
      },
      step3: {
        cities: [""],
      },
      step4: {
        instructors: [{ firstname: "", lastname: "", email: "" }],
      },
      step5: {
        administrators: [{ firstname: "", lastname: "", email: "" }],
      },
      step6: {
        accepts_online_payments: null,
        gateway: "",
        credentials: {
          authorize_api_login_id: "",
          authorize_api_trans_key: "",
          authorize_api_client_key: "",
          stripe_publishable_key: "",
          stripe_secret_key: "",
          paypal_rest_api_client_id: "",
          paypal_rest_api_secret_key: "",
          square_application_id: "",
          square_access_token: "",
        },
      },
      step7: {
        behind_the_wheel: {
          name: "",
          price: null,
          description: "",
          hours: 2,
          minutes: 0,
        },
        administers_road_tests: false,
        road_test: {
          name: "Road Test",
          price: null,
          description: "",
          hours: 1,
          minutes: 0,
        },
      },
      gatewayExplanations: {
        authorize:
          "Enter the API credentials from your Authorize.Net merchant interface: go to Account > Settings > API Credentials & Keys to find your API Login ID, generate a Transaction Key, and generate a Public Client Key.",
        stripe:
          "Enter your API keys from the Stripe dashboard: go to Developers > API keys to find your Publishable key and Secret key.",
        paypal:
          "Enter the REST API credentials from the PayPal Developer dashboard: open your live app under Apps & Credentials to find its Client ID and Secret.",
        square:
          "Enter your credentials from the Square Developer dashboard: open your application to find its production Application ID and Access Token.",
      },
      gatewayCredentialFields: {
        authorize: [
          { key: "authorize_api_login_id", label: "API Login ID" },
          { key: "authorize_api_trans_key", label: "Transaction Key" },
          { key: "authorize_api_client_key", label: "Public Client Key" },
        ],
        stripe: [
          { key: "stripe_publishable_key", label: "Publishable Key" },
          { key: "stripe_secret_key", label: "Secret Key" },
        ],
        paypal: [
          { key: "paypal_rest_api_client_id", label: "Client ID" },
          { key: "paypal_rest_api_secret_key", label: "Secret Key" },
        ],
        square: [
          { key: "square_application_id", label: "Application ID" },
          { key: "square_access_token", label: "Access Token" },
        ],
      },
    };
  },
  computed: {
    cityNames() {
      return this.step3.cities
        .map((city) => city.trim())
        .filter((city) => city.length > 0);
    },
    stepSixValid() {
      if (this.step6.accepts_online_payments === null) {
        return false;
      }
      if (this.step6.accepts_online_payments === false) {
        return true;
      }
      if (!this.step6.gateway) {
        return false;
      }
      return this.gatewayCredentialFields[this.step6.gateway].every(
        (field) => this.step6.credentials[field.key].trim().length > 0,
      );
    },
    stepSevenValid() {
      const behindTheWheel = this.step7.behind_the_wheel;
      if (!this.productValid(behindTheWheel)) {
        return false;
      }
      if (this.step7.administers_road_tests) {
        return this.productValid(this.step7.road_test);
      }
      return true;
    },
  },
  methods: {
    setStep(from, to) {
      // if going backwards, go back
      const backwards = {
        step7: "step6",
        step6: "step5",
        step5: "step4",
        step4: "step3",
        step3: "step2",
        step2: "step1",
      };
      if (backwards[from] === to) {
        this.$emit("set-step", to);
        return;
      }

      // step 1 - owner info
      if (from === "step1" && to === "step2") {
        this.$emit("save-step", {
          step: 1,
          data: { user_data: { ...this.step1 } },
        });
      }

      // step 2 - school info and address
      if (from === "step2" && to === "step3") {
        let data = {
          school_data: {
            name: this.step2.school_name,
            email: this.step2.school_email,
            phone: this.step2.school_phone,
            school_timezone: this.step2.school_timezone,
          },
          address: this.step2.address,
        };
        this.$emit("save-step", { step: 2, data: data });
      }
    },
    skipStep(step) {
      this.$emit("save-step", { step: step, data: {} });
    },
    addCity() {
      this.step3.cities.push("");
    },
    removeCity(index) {
      this.step3.cities.splice(index, 1);
    },
    saveStepThree() {
      this.$emit("save-step", {
        step: 3,
        data: { cities: this.cityNames.map((name) => ({ name })) },
      });
    },
    addInvitee(invitees) {
      invitees.push({ firstname: "", lastname: "", email: "" });
    },
    completedInvitees(invitees) {
      return invitees.filter(
        (invitee) =>
          invitee.firstname.trim().length > 0 &&
          invitee.lastname.trim().length > 0 &&
          invitee.email.trim().length > 0,
      );
    },
    saveInvitees(step, key, invitees) {
      this.$emit("save-step", {
        step: step,
        data: { [key]: this.completedInvitees(invitees) },
      });
    },
    saveStepSix() {
      if (this.step6.accepts_online_payments === false) {
        this.$emit("save-step", {
          step: 6,
          data: { accepts_online_payments: false },
        });
        return;
      }

      const credentials = {};
      this.gatewayCredentialFields[this.step6.gateway].forEach((field) => {
        credentials[field.key] = this.step6.credentials[field.key].trim();
      });

      this.$emit("save-step", {
        step: 6,
        data: {
          accepts_online_payments: true,
          gateway: this.step6.gateway,
          credentials: credentials,
        },
      });
    },
    productValid(product) {
      return (
        product.name.trim().length > 0 &&
        product.price !== null &&
        product.price !== "" &&
        product.price >= 0 &&
        (product.hours > 0 || product.minutes > 0)
      );
    },
    toProductPayload(product) {
      return {
        name: product.name.trim(),
        price: Math.round(Number(product.price) * 100),
        description: product.description,
        hours: Number(product.hours) || 0,
        minutes: Number(product.minutes) || 0,
      };
    },
    saveStepSeven() {
      const data = {
        behind_the_wheel: this.toProductPayload(this.step7.behind_the_wheel),
        administers_road_tests: this.step7.administers_road_tests,
      };

      if (this.step7.administers_road_tests) {
        data.road_test = this.toProductPayload(this.step7.road_test);
      }

      this.$emit("save-step", { step: 7, data: data });
    },
  },
};
</script>
